<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 cursor-pointer">
    <div
      v-for="item in items"
      :key="item.id"
      class="bg-white rounded-xl shadow-md overflow-hidden"
      @click="Detail(item.id)"
    >
      <div class="h-[220px]">
        <img :src="item.imageUrl" class="w-full h-full object-cover" />
      </div>
      <div class="p-4">
        <div class="text-gray-500 text-sm flex items-center">
          <i class="pi pi-clock"></i>
          <span class="pl-2">{{ formatDate(item.date) }}</span>
        </div>
        <h3 class="text-lg font-semibold mt-2 line-clamp-2">{{ item.name }}</h3>
        <div
          class="text-sm text-gray-700 mt-1 line-clamp-3"
          v-html="formatContent(item.content)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebaseConfig";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
export default {
  name: "CardNews",
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.fetchNews();
  },
  methods: {
    Detail(id) {
      this.$router.push(`/news-event-detail/${id}`);
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
    formatContent(html) {
    // Optional: Strip unwanted tags or shorten content
    if (!html) return '';
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || div.innerText || "";
    return text.length > 200 ? text.substring(0, 200) + "..." : html;
  },
    async fetchNews() {
      try {
        const q = query(collection(db, "news"), orderBy('date', 'desc'));
        const snapshot = await getDocs(q);
        this.items = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        console.log('this.items', this.items)
      } catch (error) {
        console.error("Error fetching news:", error);
      }
    },
  },
};
</script>
